import {
  UPDATE_IS_CROSS_SCHOOL_SEARCH,
  UPDATE_CROSS_SCHOOL_SEARCH_VALUE,
  UPDATE_CROSS_SCHOOL_SEARCH_FIELD,
  UPDATE_CROSS_SCHOOL_SEARCH_DO_SEARCH,
  UPDATE_CROSS_SCHOOL_SEARCH_CLEAR_SEARCH
} from "../actions/types";
const INITIAL_STATE = {
  isCrossSchoolSearch: false,
  searchValue: null,
  searchField: null,
  doSearch: false,
  clearSearch: false
};

 // eslint-disable-next-line
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_IS_CROSS_SCHOOL_SEARCH:
      return {
        ...state,
        isCrossSchoolSearch: action.payload,
      };
    case UPDATE_CROSS_SCHOOL_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
      };
    case UPDATE_CROSS_SCHOOL_SEARCH_FIELD:
      return {
        ...state,
        searchField: action.payload,
      };
    case UPDATE_CROSS_SCHOOL_SEARCH_DO_SEARCH:
      return {
        ...state,
        doSearch: action.payload,
      };
    case UPDATE_CROSS_SCHOOL_SEARCH_CLEAR_SEARCH:
      return {
        ...state,
        clearSearch: action.payload,
      };
    default:
      return state;
  }
};
